const labelCorrespondingKey = Object.freeze({
    tasks: 'tasks',
    phonecall: 'phonecalls',
    event: 'events',
});
const initializeMetasLabels = (metas) => {
    return {
        tasks: metas.task.labels,
        phonecall: metas.phonecall.labels,
    };
};

const initLabelsFilter = async (metasLabels, filter) => {
    try {
        const options = [];
        for (const groupLabel of Object.values(metasLabels)) {
            for (const label of groupLabel) {
                const optionAlreadyInFilter = options.find((option) => option.id === label.label);
                if (optionAlreadyInFilter) {
                    if (optionAlreadyInFilter.dotColor !== label.color) {
                        optionAlreadyInFilter.dotColor = label.color ?? '#000000';
                    }
                    continue;
                }

                options.push({
                    type: 'dot',
                    label: label.label,
                    id: label.label,
                    dotColor: label.color ?? '#000000',
                });
            }
        }
        filter.options = options.sort((a, b) =>
            a.label.toLowerCase().localeCompare(b.label.toLowerCase()),
        );
    } catch (error) {
        console.error(error);
    }
};

const getSelectedLabels = (values, filter, metasLabels) => {
    filter.optionsSelected = values;
    filter.value = {};
    for (const value of values) {
        for (const [key, groupLabel] of Object.entries(metasLabels)) {
            const correspondingKey = labelCorrespondingKey[key];
            const label = groupLabel.find((label) => label.label === value);
            if (label) {
                if (filter.value[correspondingKey] === undefined) {
                    filter.value[correspondingKey] = [];
                }
                if (
                    filter.value[correspondingKey] &&
                    filter.value[correspondingKey].includes(value)
                ) {
                    continue;
                }
                filter.value[correspondingKey].push(label.id);
            }
        }
    }
    return filter.value;
};

export { initializeMetasLabels, initLabelsFilter, getSelectedLabels };
